<mat-toolbar color="primary">
  <span>
    <h1>NL materieel in N schaal</h1>
  </span>
</mat-toolbar>

<mat-card>
  <p>Mijn overzicht van (recente) modellen in schaal N die rijden of hebben gereden op het Nederlandse spoor.</p>

  <p>Uitgesplitst per type en de meest kenmerkende karakteristieken waarvan de inzet jaartallen bij benadering zijn
    bepaald.</p>
</mat-card>

<mat-divider></mat-divider>

<mat-card>
  <app-ns2200></app-ns2200>
</mat-card>

<mat-divider></mat-divider>

<mat-card>
  <app-ns1200></app-ns1200>
</mat-card>

<!-- 
<mat-card>
  <h2>NS1200 (NS: 1954 - 1997)</h2>

  <section class="mat-typography">

    <div style="text-align:center">

      <apx-chart [series]="ns1200.series" [chart]="ns1200.chart" [fill]="ns1200.fill"
        [grid]="ns1200.grid" [dataLabels]="ns1200.dataLabels" [plotOptions]="ns1200.plotOptions"
        [xaxis]="ns1200.xaxis" [yaxis]="ns1200.yaxis" [title]="ns1200.title"
        [tooltip]="ns1200.tooltip"></apx-chart>

    </div>

  </section>

</mat-card>-->
